import { styled } from '@mui/material/styles';
import { brandclub_colors } from '@stackline/ui';

export const Card = styled('div')({
  background: brandclub_colors.white,
  border: '1px solid #E6ECF2',
  borderRadius: 8,
  padding: 24,
});

export const TwoCol = styled('div')({
  display: 'grid',
  gridTemplateColumns: 'minmax(0, 1fr) minmax(320px, 336px)',
  gap: 32
});

export const FieldLabel = styled('div')({
  fontSize: 12,
  color: '#0E1E3A',
  marginBottom: 8,
  fontWeight: 600
});

export const Input = styled('input')({
  width: '100%',
  padding: '10px 12px',
  border: '1px solid #E6ECF2',
  borderRadius: 6,
  fontSize: 14
});

export const RadioRow = styled('div')({
  display: 'grid',
  gridTemplateColumns: '1fr 1fr',
  gap: 24,
  marginTop: 8
});

export const RadioCard = styled('label')<{ selected?: boolean }>(({ selected }) => ({
  display: 'block',
  border: `1px solid ${selected ? '#356AE6' : '#E6ECF2'}`,
  borderRadius: 8,
  padding: 12,
  fontSize: 12,
  lineHeight: 1.5
}));

export const Chip = styled('button')<{ selected?: boolean }>(({ selected }) => ({
  fontSize: 12,
  borderRadius: 14,
  padding: '6px 10px',
  border: `1px solid ${selected ? '#356AE6' : '#E6ECF2'}`,
  background: selected ? '#ECF2FF' : brandclub_colors.white,
  color: selected ? '#0E1E3A' : '#031425',
  cursor: 'pointer'
}));

export const DangerBar = styled('div')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  background: '#FFF1F2',
  border: '1px solid #FECACA',
  color: '#991B1B',
  borderRadius: 8,
  padding: 12
});

export const Primary = styled('button')({
  background: '#0E1E3A',
  color: '#ffffff',
  borderRadius: 6,
  padding: '8px 14px',
  border: 'none',
  cursor: 'pointer'
});

export const Secondary = styled('button')({
  background: '#FFF',
  color: '#031425',
  borderRadius: 6,
  padding: '8px 14px',
  border: '1px solid #D7E3FF',
  fontFamily: 'Roboto',
  fontSize: 14,
  fontStyle: 'normal',
  fontWeight: 500,
  lineHeight: '20px',
  letterSpacing: '0.08px',
});

export const Select = styled('select')({
  width: '100%',
  padding: '10px 12px',
  border: '1px solid #E6ECF2',
  borderRadius: 6,
  fontSize: 14,
  background: brandclub_colors.white
});

export const List = styled('div')({
  border: '1px solid #E6ECF2',
  borderRadius: 8
});

export const ListRow = styled('div')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '12px 14px',
  borderBottom: '1px solid #E6ECF2'
});

export const Toggle = styled('input')({
  width: 36,
  height: 18
});

export const SmallMeta = styled('div')({
  fontSize: 12,
  color: '#7E8FA8'
});

export const SectionTitle = styled('div')({
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  fontFamily: 'Roboto',
  fontSize: 20,
  fontWeight: 700,
  lineHeight: '28px',
  marginBottom: 8
});

export const SectionSubtext = styled('div')({
  color: 'var(--primary-031425, #031425)',
  fontFeatureSettings: "'liga' off, 'clig' off",
  fontFamily: 'Roboto',
  fontSize: 16,
  fontWeight: 400,
  lineHeight: '24px',
  letterSpacing: '0.08px',
  marginBottom: 16
});

export const SearchRow = styled('div')({
  display: 'flex',
  marginBottom: 16
});

export const SearchInput = styled('input')({
  width: 320,
  padding: '10px 12px',
  border: '1px solid #E6ECF2',
  borderRadius: 6,
  fontSize: 14
});

export const TemplateGrid = styled('div')({
  display: 'grid',
  gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
  gap: 16
});

export const TemplateCard = styled('div')<{ disabled?: boolean }>(({ disabled }) => ({
  border: '1px solid #E6ECF2',
  borderRadius: 8,
  background: brandclub_colors.white,
  padding: 16,
  width: 336,
  height: 197,
  opacity: disabled ? 0.55 : 1
}));

export const TemplateHeader = styled('div')({
  fontWeight: 700,
  marginBottom: 8,
  fontSize: 16,
});

export const TemplateDesc = styled('div')({
  fontSize: 14,
  color: '#031425',
  marginBottom: 10
});

export const TagRow = styled('div')({
  display: 'flex',
  gap: 8,
  flexWrap: 'wrap',
  marginBottom: 12
});

export const Tag = styled('span')({
  fontSize: 12,
  fontWeight: 400,
  color: '#7E8FA8',
  background: '#F1F5F9',
  border: '1px solid #E6ECF2',
  borderRadius: 8,
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: 24,
  padding: '0 10px',
  lineHeight: '24px',
  width: 'fit-content',
  textAlign: 'center'
});

export const MetaRow = styled('div')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  marginTop: 16,
  paddingTop: 16,
  minHeight: 44,
  borderTop: '1px solid #E6ECF2'
});

export const CreateButton = styled('button')<{ disabled?: boolean }>(({ disabled }) => ({
  display: 'flex',
  padding: '3px 20px',
  justifyContent: 'center',
  alignItems: 'center',
  gap: 8,
  borderRadius: 16,
  border: '1px solid #E8E8ED',
  background: '#FFF',
  color: '#031425',
  fontFeatureSettings: "'liga' off, 'clig' off",
  fontFamily: 'Roboto',
  fontSize: 12,
  fontStyle: 'normal',
  fontWeight: 500,
  lineHeight: '18px',
  letterSpacing: '0.08px',
  cursor: disabled ? 'not-allowed' : 'pointer',
  opacity: disabled ? 0.5 : 1
}));

export const KVRow = styled('div')({
  display: 'grid',
  gridTemplateColumns: '180px 1fr',
  gap: 16,
  padding: '10px 0',
});

export const KVLabel = styled('div')({
  overflow: 'hidden',
  color: 'var(--primary-031425, #031425)',
  fontFeatureSettings: "'liga' off, 'clig' off",
  textOverflow: 'ellipsis',
  fontFamily: 'Roboto',
  fontSize: 14,
  fontStyle: 'normal',
  fontWeight: 700,
  lineHeight: '20px',
  letterSpacing: '0.08px',
  whiteSpace: 'nowrap'
});

export const KVValue = styled('div')({
  color: '#031425',
  fontFamily: 'Roboto',
  fontSize: 14,
  fontWeight: 400,
  lineHeight: '20px'
});

export const LaunchButton = styled('button')({
  background: '#42B883',
  color: brandclub_colors.white,
  border: 'none',
  borderRadius: 6,
  padding: '10px 16px',
  cursor: 'pointer'
});

// Calendar parts
export const CalendarWrap = styled('div')({
  display: 'grid',
  gridTemplateColumns: '1fr 1fr',
  gap: 16,
  marginTop: 8
});

export const MonthWrap = styled('div')({
  border: '1px solid #E6ECF2',
  borderRadius: 8,
  padding: 12
});

export const MonthHeader = styled('div')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  fontSize: 12,
  marginBottom: 8
});

export const ArrowBtn = styled('button')({
  background: 'transparent',
  border: 'none',
  cursor: 'pointer',
  fontSize: 16,
  color: '#031425'
});

export const WeekRow = styled('div')({
  display: 'grid',
  gridTemplateColumns: 'repeat(7, 1fr)',
  gap: 6,
  fontSize: 10,
  color: '#031425',
  textAlign: 'center',
  marginBottom: 6
});

export const Grid = styled('div')({
  display: 'grid',
  gridTemplateColumns: 'repeat(7, 1fr)',
  gap: 6
});

export const DayCell = styled('button')<{ inRange?: boolean; selected?: boolean; muted?: boolean }>(({ inRange, selected, muted }) => ({
  height: 28,
  borderRadius: 6,
  border: '1px solid ' + (selected ? '#356AE6' : 'transparent'),
  background: selected ? '#ECF2FF' : inRange ? '#F5F8FF' : brandclub_colors.white,
  color: muted ? '#B6C2D2' : '#0E1E3A',
  cursor: 'pointer',
  fontSize: 12
}));


export const TemplateInputHeader = styled('div')({
  fontWeight: 700,
  marginBottom: 8,
  fontSize: 16,
});

// Date range utilities (shared across tabs)
export type DateRangeValue = '1d' | '7d' | '30d' | 'all';

export const DATE_RANGE_OPTIONS: { value: DateRangeValue; label: string }[] = [
  { value: '1d', label: 'Last 1 Day' },
  { value: '7d', label: 'Last 7 Days' },
  { value: '30d', label: 'Last 30 Days' },
  { value: 'all', label: 'All Time' }
];

export const dateRangeLabelFromValue = (range: DateRangeValue): string => {
  const found = DATE_RANGE_OPTIONS.find((o) => o.value === range);
  return found ? found.label : 'Last 7 Days';
};

export const isTimestampWithinRange = (
  timestampMs: number | null | undefined,
  range: DateRangeValue,
  nowMs: number = Date.now()
): boolean => {
  if (range === 'all') return true;
  if (typeof timestampMs !== 'number' || !Number.isFinite(timestampMs)) return false;
  const msInDay = 24 * 60 * 60 * 1000;
  const windowDays = range === '1d' ? 1 : range === '7d' ? 7 : 30;
  const threshold = nowMs - windowDays * msInDay;
  return timestampMs >= threshold;
};